"use client";

import { ospThemes } from "@ospweb/sdk-ui";
import type { DrawerProps } from "antd";
import {
  EdgenDrawerCallable,
  EdgenDrawerCallableProps,
} from "../EdgenDrawerCallable";
import { Question } from "../Sender/QuestionItem";
import { ChatModalContent, ChatTabContent } from "./ChatModalContent";
import { IOnCreateParams } from "@hooks/useCreateChat";

export type IChatInfo = IOnCreateParams;

export interface ChatModalCallableParams extends EdgenDrawerCallableProps {
  placement?: DrawerProps["placement"];
  width?: number;
  chatInfo?: IChatInfo;
  /**
   * @description 关闭弹窗时触发的回调
   * @type () => void
   * @required false
   */
  onClose?: () => void;
  questions?: Question[];
}

/**
 * 可调用的 ChatModal
 * 复用 EdgenDrawerCallable 的 root 节点
 *
 * 使用方式:
 * await ChatModalCallable({ chatInfo: { question: "xxx" } })
 */
export const ChatModalCallable = async (
  params?: ChatModalCallableParams,
): Promise<boolean> => {
  const {
    placement = "right",
    width = 800,
    chatInfo,
    onClose,
    styles,
    questions,
    ...restProps
  } = params || {};

  const contentClassName =
    restProps.draggable && placement === "bottom"
      ? "pb-0 overflow-hidden min-h-0"
      : "pb-0 overflow-y-auto";

  // 使用 .call() 方法来调用 EdgenDrawerCallable
  const result = await EdgenDrawerCallable.call({
    placement,
    width,
    isHiddenClose: true,
    isMask: false,
    closeOnContentBlankClick: true,
    styles: {
      ...styles,
      body: {
        backgroundColor: ospThemes.colors.background_solid_tertiary,
        ...styles?.body,
      },
    },
    contentClassName,
    onClose,
    children: (
      <ChatModalContent
        chatInfo={chatInfo}
        questions={questions}
        onClose={onClose}
      />
    ),
    ...restProps, // 传递其他参数，包括 draggable, initDistance, dragThreshold
  });

  return result;
};

export { ChatTabContent };
